import { Heading, Subheading } from "../../../../design/heading";
import { useDiscoveryRequest } from "../../../../contexts/DiscoveryRequestContext";
import EmptyStateView from "../../../../components/EmptyStateView";
import LoadingView from "../../../../components/LoadingView";
import ErrorView from "../../../../components/ErrorView";
import { useState, useMemo } from "react";
import DiscoveryRequestTasksListItem from "./DiscoveryRequestTaskListItem";
import TaskButton from "../../../../components/TaskButton";
import { useCreateDiscoveryRequestTaskDialog } from "../../../../providers/CreateDiscoveryRequestTaskDialogProvider";
import { Button } from "../../../../design/button";
import { PlusIcon } from "@heroicons/react/20/solid";

interface DiscoveryRequestTasksListProps {
  discoveryRequestId: string;
}

const DiscoveryRequestTasksList: React.FC<DiscoveryRequestTasksListProps> = ({
  discoveryRequestId,
}) => {
  const { tasks, loading, error } = useDiscoveryRequest();
  const { openDialog } = useCreateDiscoveryRequestTaskDialog();

  if (loading.tasks) {
    return <LoadingView title="Loading Tasks..." />;
  }

  if (error.tasks) {
    return <ErrorView error={error.tasks} />;
  }

  if (!tasks) {
    return <ErrorView error={new Error("Tasks not found")} />;
  }

  return (
    <div className="mt-6 space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Subheading>Tasks</Subheading>
        </div>
        <Button onClick={() => openDialog(discoveryRequestId)}>
          <>
            <PlusIcon className="w-4 h-4" />
            <span className="hidden sm:block">Add Task</span>
          </>
        </Button>
      </div>

      {tasks.length === 0 ? (
        <EmptyStateView
          title="No Tasks"
          message="No tasks found. Create a task to get started."
        />
      ) : (
        <div className="space-y-4">
          {tasks.map((task) => (
            <DiscoveryRequestTasksListItem task={task} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DiscoveryRequestTasksList;
